import { useMutation } from '@tanstack/react-query'
import { ScreenPath } from '../../navigation'
import { authService } from '../../service/domain/_service.config'

export function useResetPassword() {
  return useMutation({
    mutationFn: async (email: string) => {
      await authService.resetPassword(
        email,
        `${process.env.REACT_APP_BASE_URL}${ScreenPath.resetPassword}`,
      )
    },
  })
}
